<template>
    <v-card dark :color="COLOR.CLICK_MENU_COLOR" class="">
        <v-card-text class="px-2 pt-12 white--text text-center">
            <v-avatar>
                <img :src="default_avatar" alt="">
            </v-avatar>
            <p class="mt-3 body-1 indigo--text font-weight-bold ">
                <span class="st-username">{{currentUser.username}}</span><br>
                <!--                        <span class="orange&#45;&#45;text" >Vip member</span><br>-->
                <strong class="black--text st-coin">{{ currentUser.customer.coin | currency }}</strong>
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
    import { COLOR } from "~/config/constant";
    export default {
        name: "attention",

        data() {
            return {
                // Color chinh
                COLOR: COLOR,
                default_avatar : 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRb3cKuVSY5yQSumCbZVZJf05ere11Tt1sOSRrNYc425RBOUjS0',
            }
        },
        computed: {
            currentUser() {
                console.log("change");
                return  JSON.parse(localStorage.getItem("currentUser"));
            }
        },
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .text-color-btn {
        color: $clickMenuColor;
    }

</style>
